import PremiumPaywallPopover from "components/conversion/PremiumPaywallPopover";
import classNames from "components/ui/classNames";
import useSelfie from "lib/hooks/useSelfie";
import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

interface BoxedChartHeaderProps {
  paywallDisplayOrigin?: string;
  tickerSymbol: string;
  title: ReactNode;
  subtitle?: ReactNode;
  isNewStuff?: boolean;
}
export default function BoxedChartHeader({
  paywallDisplayOrigin,
  tickerSymbol,
  title,
  subtitle,
  isNewStuff = false,
}: BoxedChartHeaderProps) {
  const viewer = useSelfie();

  return (
    <div className="inline-flex flex-col gap-2">
      <div className="inline-flex flex-col gap-1 md:flex-row md:items-center md:gap-2">
        <h1 className="inline-flex text-xl font-black text-slate-800 dark:text-slate-100 sm:text-2xl">{title}</h1>
        <div className="flex items-center gap-2">
          <span
            className={classNames(
              "rounded-md px-2 py-1 text-xs font-bold tracking-wider",
              "bg-violet-50 text-violet-600",
              "dark:bg-orange-300/30 dark:text-orange-100",
              "inline-flex",
            )}
          >
            {tickerSymbol.toUpperCase()}
          </span>
          {!viewer?.isPremium && paywallDisplayOrigin && (
            <PremiumPaywallPopover displayOrigin={paywallDisplayOrigin} isEnabled={true}>
              <span
                className={classNames(
                  "rounded-md px-2 py-1 text-xs font-bold tracking-wider",
                  "bg-orange-50 text-orange-600",
                  "dark:bg-orange-300/30 dark:text-orange-100",
                )}
              >
                <FormattedMessage
                  defaultMessage="Só no Premium..."
                  id="v6O2ln"
                  description="Tag só no Premium - Paywall"
                />
              </span>
            </PremiumPaywallPopover>
          )}
          {isNewStuff && (
            <span
              className={classNames(
                "rounded-md px-2 py-1 text-xs font-bold tracking-wider",
                "bg-orange-50 text-orange-600",
                "dark:bg-orange-300/30 dark:text-orange-100",
                "inline-flex",
              )}
            >
              <FormattedMessage defaultMessage="Novidade" id="yC7RnY" />
            </span>
          )}
        </div>
      </div>

      {subtitle && (
        <p className="inline-flex items-center space-x-1.5 text-sm italic tracking-wide text-slate-500 dark:text-slate-400">
          {subtitle}
        </p>
      )}
    </div>
  );
}
